import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, RadioGroup } from '@leasequery/lq.react-component-library'
import Question from '../body/Question'

export default function RadioForm({
	nav,
	promptNum,
	submitAnswer,
	value,
	subQuestion = '',
	subValue = '',
}) {
	let history = useHistory()
	const [radioButton, setRadioButton] = useState(value)
	const [subRadioButton, setSubRadioButton] = useState(subValue)
	const [errorMessage, setErrorMessage] = useState('')

	const options = [
		{
			key: 0,
			value: 'Yes',
			label: 'Yes',
		},
		{
			key: 1,
			value: 'No',
			label: 'No',
		},
	]

	const subOptions = [
		{
			key: 0,
			value: 'subYes',
			label: 'Yes',
		},
		{
			key: 1,
			value: 'subNo',
			label: 'No',
		},
	]

	if (nav.navNA) {
		options.push({
			key: 2,
			value: 'N/A',
			label: 'Does not apply',
		})
	}

	async function navigateForward() {
		const isSubQuestionVisible =
			subQuestion && radioButton === 'Yes' ? true : false
		const isQuestionAnswered = radioButton ? true : false
		const isSubQuestionAnswered =
			isSubQuestionVisible && subRadioButton ? true : false

		if (
			(isQuestionAnswered && isSubQuestionAnswered) ||
			(isQuestionAnswered && !isSubQuestionVisible)
		) {
			setErrorMessage('')

			if (isSubQuestionAnswered) {
				submitAnswer(promptNum, radioButton, subRadioButton)
			} else {
				submitAnswer(promptNum, radioButton)
			}

			// edge case for SBITA question 5
			if (nav.navSbitaFive) {
				if (radioButton === 'No') {
					history.push(nav.navNo)
				} else if (radioButton === 'Yes' && subRadioButton === 'subYes') {
					history.push(nav.navYes)
				} else if (radioButton === 'Yes' && subRadioButton === 'subNo') {
					history.push(nav.navNo)
				}
			}

			if (!nav.navSbitaFive) {
				if (
					radioButton === 'No' ||
					(radioButton === 'Yes' && subRadioButton === 'subYes')
				) {
					history.push(nav.navNo)
				} else if (radioButton === 'Yes' || radioButton === 'N/A') {
					history.push(nav.navYes)
				}
			}

			sessionStorage.setItem('formActive', '1')
		} else {
			setErrorMessage(`Please select an answer`)
		}
	}

	function navigateBack() {
		sessionStorage.setItem('formActive', '1')
		history.goBack()
	}

	return (
		<div className='form-Container'>
			<div className='radioGroup'>
				<RadioGroup
					name='question'
					required={true}
					selectedValue={radioButton}
					options={options}
					onChange={(value) => {
						setRadioButton(value)
					}}
				/>
			</div>

			{subQuestion && radioButton === 'Yes' && (
				<>
					<Question question={subQuestion} />

					<div className='radioGroup' style={{ marginTop: '20px' }}>
						<RadioGroup
							name='subQuestion'
							required={true}
							selectedValue={subRadioButton}
							options={subOptions}
							onChange={(subValue) => {
								setSubRadioButton(subValue)
							}}
						/>
					</div>
				</>
			)}

			<div className='errorMessage-Container'>{errorMessage}</div>

			<div>
				{promptNum !== 1 && (
					<Button
						buttonType='secondary'
						className='form-Button'
						onClick={() => navigateBack()}
					>
						Back
					</Button>
				)}
				<Button
					buttonType='primary'
					className='form-Button'
					onClick={() => navigateForward()}
				>
					Next
				</Button>
			</div>
		</div>
	)
}
